import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as constants from '@config/constants';
import { fetchAndParseResponse } from '@utils/fetchUtils';

const useFetch = (url, options, timestamp = '', mock = false) => {
  const dispatch = useDispatch();

  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      useDispatch && dispatch({ type: constants.XHR_IN_PROGRESS, key: url });

      if (mock) {
        setResponse(mock);
        setIsLoading(false);
        return;
      }

      const { response, error } = await fetchAndParseResponse(url, options);

      setResponse(response);
      setIsLoading(false);
      useDispatch && dispatch({ type: constants.XHR_COMPLETE, key: url });

      if (error) {
        setError(error);
      }
    };
    fetchData();
  }, [url, timestamp]);
  return { response, error, isLoading };
};

export default useFetch;
